module.exports = __webpack_public_path__ + "img/working-2.40d62e97.png";